import { render } from "./modalAddIdConfigd.vue?vue&type=template&id=650a561f"
import script from "./modalAddIdConfigd.vue?vue&type=script&lang=js"
export * from "./modalAddIdConfigd.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__